import { MerchantRecommendedExchangeSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/merchant-recommended-exchange";
import * as z from "zod/v4";

export const getMerchantRecommendedExchanges = {
  name: "getMerchantRecommendedExchanges" as const,
  input: z.object({}),
  output: z.object({
    enableMerchantRecommendedExchanges: z.boolean(),
    merchantRecommendedExchanges: z.array(MerchantRecommendedExchangeSchema),
  }),
};
